<template>
  <div class="container intro-section checkout-success center-page-content">
    <div class="row checkout-success__content">
      <div class="col text-center">
        <Icon name="grCheckCircleBroken" width="36" class="mb-3"/>
        <template v-if="isBankTransferPayment">
          <h1 class="title">{{ $t('pages.checkout_success.title_bank_transfer') }}</h1>
          <h2 class="subtitle" v-html="$t('pages.checkout_success.title_bank_transfer_subtitle')"></h2>
        </template>
        <template v-else>
          <h1 class="title"> {{ $t('pages.checkout_success.title') }}</h1>
        </template>
        <div v-if="!isBankTransferPayment">
          <b-button variant="primary" :to="{ name: 'checkins-list'}" class="mt-4">
            {{ $t('pages.checkout_success.action_go_to_events') }}</b-button>
        </div>

        <div v-if="isBankTransferPayment" class="mt-5">
          <div class="font-weight-medium text-secondary mb-3">
            {{ $t('pages.checkout_success.bank_account_details') }}
          </div>

          <div class="table-w table-w--borderded mb-3">
            <table class="table">
              <tbody>
              <tr class="" v-for="(item, index) in dataTableBankTransfer" :key="index">
                <td class="text-left label">{{ item.label }}</td>
                <td class="text-right text-nowrap">
                  {{ item.value }} <a href="#" @click.prevent="copy(item.value)"><Icon class="ml-1 label" name="copy" width="20"/>
                </a></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="table-w total mb-4">
            <table class="table table-borderless">
              <tbody>
              <tr>
                <td class="text-left">{{ $t('pages.checkout_success.bank_account_amount') }}</td>
                <td class="text-right"><span class="order-amount">{{ order.price_grandtotal|formatCurrency(order.currency) }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="checkout-success__footer">
            <div v-html="toDoText">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {getContactUrl} from "@/utils";
import {mapActions} from "vuex";
import {payModes} from "@/domain/checkout/constants";

export default {
  props: {
    orderId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      order: {}
    }
  },

  beforeMount() {
    window.scrollTo(0, 0);
  },

  async mounted() {
    if (this.orderId) {
      this.order = await this.fetchOrder(this.orderId)
    } else {
      this.$set(this.order, 'order_number', '1111-22222-333333')
    }
  },

  computed: {
    isBankTransferPayment() {
      if (!this.order) return
      return this.order.payment_method === payModes.BANK_TRANSFER
    },
    toDoText() {
      return this.$t('pages.checkout_success.bank_transfer_todo',
          {email: `<a href="${this.getContactUrl()}" target="_blank">support@getpica.com</a>`})
    },
    dataTableBankTransfer() {
      return [
        {
          label: this.$t('pages.checkout_success.bank_account_headed_to'),
          value: 'PICA GROUP SPA',
        },
        {
          label: 'IBAN',
          value: 'IT 15 Q 03047 01600 000222002841',
        },
        {
          label: this.$t('pages.checkout_success.bank_account_swift'),
          value: 'CAOTIT31XXX',
        },
        {
          label: this.$t('pages.checkout_success.bank_account_reason_for_payment'),
          value: this.order.order_number,
        }
      ]
    }
  },

  methods: {
    ...mapActions('cartDigitalItems', ['fetchOrder']),
    getContactUrl,
    copy(value) {
      navigator.clipboard.writeText(value)
      this.$bvToast.toast(this.$t('notifications.text_copied'))
    }
  }
}
</script>
